import { useAuthContext } from '@aibees/shared/auth';
import { MemberType } from '@aibees/shared/definition';
import { useWorkspace } from '../context';

export function useGetUserRole() {
  const { user } = useAuthContext();
  const workspace = useWorkspace();

  const isOwner = workspace?.user.id === user?.id;
  if (isOwner) {
    return MemberType.Owner;
  }

  const loggedInUserMemberInfo = workspace?.members.find(
    (x) => x.user?.id === user?.id
  );

  return loggedInUserMemberInfo?.type ?? MemberType.User;
}
